module.exports = __webpack_public_path__ + "img/11825393_L.59c43591.png";